import http from "@/plugins/axios_plugin";

class ServiceAdministradores {
  index(admin_id) {
    return http.get("/api/administradores/config/listar?id=" + admin_id);
  }

  salvarConfig(admin) {
    return http.post("/api/administradores/config/salvar", admin);
  }

  listar() {
    return http.get("/api/administradores/listar");
  }

  salvar(administrador) {
    return http.post("/api/administradores/salvar", administrador);
  }

  editar(administrador_id) {
    return http.get("/api/administradores/" + administrador_id + "/editar");
  }

  atualizar(administrador) {
    return http.post(
      "/api/administradores/" + administrador.id + "/atualizar",
      administrador
    );
  }

  excluir(administrador) {
    return http.post("/api/administradores/" + administrador + "/excluir");
  }

  carregarRepresentantes() {
    return http.get("/api/representantes/listar/lista");
  }
}

export default new ServiceAdministradores();
